<template>
    <div class="dialog">
        <!-- <el-dialog
      :title="title"
      custom-class="listDialog"
      width="500px"
      style="padding-bottom:30px"
      :visible.sync="leftDialog"
      @close="close"
    ></el-dialog> -->
        <div class="bigBox">
            <div class="box" v-for="item in staff" :key="item.uid">
                <el-radio v-model="radio" :label="item.uid">
                    {{ item.username }}
                </el-radio>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        staff: {
            type: Array,
            default: [],
        },
    },
    data() {
        return {
            radio: '',
        }
    },
    watch: {
        radio(val) {
            this.$emit('checkRadio', val)
        },
    },
    methods: {
        init() {
            this.radio = ''
        },
    },
}
</script>

<style lang="scss">
.dialog {
    display: flex;
    justify-content: space-between;
    .bigBox {
        width: 500;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .box {
            width: 30%;
            margin-bottom: 10px;
        }
    }
}
</style>
